import React from 'react';

export default function PricingPage({ setPage, user, handleLogout }) {
    return (
        <div style={{ minHeight: '100vh', background: 'white' }}>
            {/* Header */}
            <header style={{ 
                padding: '16px 24px', 
                display: 'flex', 
                justifyContent: 'space-between', 
                alignItems: 'center',
                borderBottom: '1px solid #e5e7eb'
            }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
                    <button 
                        onClick={() => setPage('search')} 
                        style={{ 
                            background: 'none', 
                            border: 'none', 
                            cursor: 'pointer', 
                            color: '#1d2934', 
                            fontSize: '16px',
                            display: 'flex',
                            alignItems: 'center',
                            gap: '8px'
                        }}
                    >
                        ← Back
                    </button>
                    <img 
                        src="/logo.svg" 
                        alt="PatTrak Logo" 
                        style={{ height: '32px', cursor: 'pointer' }} 
                        onClick={() => setPage('search')}
                    />
                </div>
                {user ? (
                    <button 
                        onClick={handleLogout} 
                        style={{ 
                            background: 'none', 
                            border: '1px solid #e5e7eb', 
                            padding: '8px 16px',
                            borderRadius: '6px',
                            cursor: 'pointer', 
                            color: '#1d2934' 
                        }}
                    >
                        Logout
                    </button>
                ) : (
                    <button 
                        onClick={() => setPage('login')} 
                        style={{ 
                            background: '#3b82f6', 
                            color: 'white',
                            border: 'none', 
                            padding: '8px 16px',
                            borderRadius: '6px',
                            cursor: 'pointer',
                            fontWeight: '600'
                        }}
                    >
                        Sign In
                    </button>
                )}
            </header>

            {/* Hero Section */}
            <div style={{ 
                maxWidth: '1200px', 
                margin: '60px auto 40px', 
                padding: '0 24px',
                textAlign: 'center'
            }}>
                <h1 style={{ 
                    fontSize: '42px', 
                    fontWeight: '700', 
                    color: '#1d2934', 
                    marginBottom: '16px',
                    lineHeight: '1.2'
                }}>
                    Simple, Transparent Pricing
                </h1>
                <p style={{ 
                    fontSize: '20px', 
                    color: '#64748b', 
                    marginBottom: '8px'
                }}>
                    Choose the plan that's right for you
                </p>
                <p style={{ 
                    fontSize: '16px', 
                    color: '#94a3b8', 
                    marginBottom: '48px'
                }}>
                    All plans include patent search, analysis, and visualization. Upgrade anytime.
                </p>
            </div>

            {/* Pricing Cards */}
            <div style={{ 
                maxWidth: '1200px', 
                margin: '0 auto', 
                padding: '0 24px 80px',
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(320px, 1fr))',
                gap: '24px'
            }}>
                
                {/* FREE TIER */}
                <div style={{ 
                    border: '2px solid #e5e7eb',
                    borderRadius: '16px',
                    padding: '32px',
                    background: 'white',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <div style={{ marginBottom: '24px' }}>
                        <h3 style={{ 
                            fontSize: '24px', 
                            fontWeight: '700', 
                            color: '#1d2934',
                            marginBottom: '8px'
                        }}>
                            Free
                        </h3>
                        <p style={{ 
                            fontSize: '14px', 
                            color: '#64748b',
                            marginBottom: '16px'
                        }}>
                            Perfect for trying out PatTrak
                        </p>
                        <div style={{ marginBottom: '16px' }}>
                            <span style={{ 
                                fontSize: '48px', 
                                fontWeight: '700', 
                                color: '#1d2934'
                            }}>
                                £0
                            </span>
                            <span style={{ 
                                fontSize: '16px', 
                                color: '#64748b'
                            }}>
                               
                            </span>
                        </div>
                    </div>

                    <ul style={{ 
                        listStyle: 'none', 
                        padding: 0, 
                        margin: '0 0 32px 0',
                        flexGrow: 1
                    }}>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>Patent/Company/Inventor search</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>10 AI searches/day</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span><strong>8 Quick Analyses/day</strong> (2 full + 6 preview)</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>5 Application searches/day</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>2 Company Intel/day</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>Compare 2 patents</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>Save 10 patents, 5 searches</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>Export 20 patents to CSV</span>
                        </li>
                    </ul>

                    <button 
                        onClick={() => setPage('register')}
                        style={{ 
                            width: '100%',
                            padding: '14px',
                            background: 'white',
                            border: '2px solid #e5e7eb',
                            borderRadius: '8px',
                            color: '#1d2934',
                            fontSize: '16px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                        onMouseOver={(e) => e.target.style.background = '#f9fafb'}
                        onMouseOut={(e) => e.target.style.background = 'white'}
                    >
                        Get Started Free
                    </button>
                </div>

                {/* PREMIUM TIER */}
                <div style={{ 
                    border: '2px solid #3b82f6',
                    borderRadius: '16px',
                    padding: '32px',
                    background: 'white',
                    position: 'relative',
                    display: 'flex',
                    flexDirection: 'column',
                    boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
                }}>
                    <div style={{
                        position: 'absolute',
                        top: '-12px',
                        left: '50%',
                        transform: 'translateX(-50%)',
                        background: '#3b82f6',
                        color: 'white',
                        padding: '4px 16px',
                        borderRadius: '12px',
                        fontSize: '12px',
                        fontWeight: '700',
                        letterSpacing: '0.5px'
                    }}>
                        MOST POPULAR
                    </div>

                    <div style={{ marginBottom: '24px' }}>
                        <h3 style={{ 
                            fontSize: '24px', 
                            fontWeight: '700', 
                            color: '#1d2934',
                            marginBottom: '8px'
                        }}>
                            Premium
                        </h3>
                        <p style={{ 
                            fontSize: '14px', 
                            color: '#64748b',
                            marginBottom: '16px'
                        }}>
                            For professionals and researchers
                        </p>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{ 
                                fontSize: '48px', 
                                fontWeight: '700', 
                                color: '#1d2934'
                            }}>
                                Contact Us
                            </span>
                            <span style={{ 
                                fontSize: '16px', 
                                color: '#64748b'
                            }}></span>
                        </div>
                        <p style={{ 
                            fontSize: '14px', 
                            color: '#3b82f6',
                            fontWeight: '600'
                        }}>
                            Flexible billing options
                        </p>
                    </div>

                    <ul style={{ 
                        listStyle: 'none', 
                        padding: 0, 
                        margin: '0 0 32px 0',
                        flexGrow: 1
                    }}>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>50 AI searches/day</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span><strong>20 Quick + 10 Standard</strong> analyses/day</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>20 Application searches/day</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>10 Company Intel/day</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>5 Citation analyses/day</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>Citation Network visualization</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>Full Landscape charts</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>Compare 3 patents</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>Save 100 patents, 50 searches</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>Export 100 patents to CSV</span>
                        </li>
                    </ul>

                    <button 
                        onClick={() => alert('Premium upgrade coming soon!')}
                        style={{ 
                            width: '100%',
                            padding: '14px',
                            background: '#3b82f6',
                            border: 'none',
                            borderRadius: '8px',
                            color: 'white',
                            fontSize: '16px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                        onMouseOver={(e) => e.target.style.background = '#2563eb'}
                        onMouseOut={(e) => e.target.style.background = '#3b82f6'}
                    >
                        Contact Us
                    </button>
                </div>

                {/* PRO TIER */}
                <div style={{ 
                    border: '2px solid #8b5cf6',
                    borderRadius: '16px',
                    padding: '32px',
                    background: 'linear-gradient(135deg, #faf5ff 0%, #ffffff 100%)',
                    display: 'flex',
                    flexDirection: 'column'
                }}>
                    <div style={{ marginBottom: '24px' }}>
                        <h3 style={{ 
                            fontSize: '24px', 
                            fontWeight: '700', 
                            color: '#1d2934',
                            marginBottom: '8px'
                        }}>
                            Pro
                        </h3>
                        <p style={{ 
                            fontSize: '14px', 
                            color: '#64748b',
                            marginBottom: '16px'
                        }}>
                            For power users and TTOs
                        </p>
                        <div style={{ marginBottom: '8px' }}>
                            <span style={{ 
                                fontSize: '48px', 
                                fontWeight: '700', 
                                color: '#1d2934'
                            }}>
                                Contact Us
                            </span>
                            <span style={{ 
                                fontSize: '16px', 
                                color: '#64748b'
                            }}>
                               
                            </span>
                        </div>
                        <p style={{ 
                            fontSize: '14px', 
                            color: '#8b5cf6',
                            fontWeight: '600'
                        }}>
                            Tailored to your needs
                        </p>
                    </div>

                    {/* ROI Banner */}
                    <div style={{
                        background: '#fef3c7',
                        border: '1px solid #fbbf24',
                        borderRadius: '8px',
                        padding: '12px',
                        marginBottom: '20px'
                    }}>
                        <p style={{ 
                            fontSize: '13px', 
                            color: '#92400e',
                            fontWeight: '600',
                            margin: 0,
                            lineHeight: '1.4'
                        }}>
                            TTO screening tools: Generate attorney-ready Prior Art and FTO reports for preliminary assessment. Save weeks before engaging outside counsel.
                        </p>
                    </div>

                    <ul style={{ 
                        listStyle: 'none', 
                        padding: 0, 
                        margin: '0 0 32px 0',
                        flexGrow: 1
                    }}>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span><strong>Unlimited</strong> AI searches</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span><strong>Unlimited Quick/Standard/Deep</strong> analyses</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px',
                            borderTop: '1px solid #e5e7eb',
                            fontWeight: '600'
                        }}>
                            <span style={{ color: '#8b5cf6', fontWeight: '700' }}>★</span>
                            <span style={{ color: '#8b5cf6' }}>FTO Pro Reports (US, UK/EPO, EPO Strict)</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px',
                            fontWeight: '600'
                        }}>
                            <span style={{ color: '#8b5cf6', fontWeight: '700' }}>★</span>
                            <span style={{ color: '#8b5cf6' }}>Prior Art Pro (Attorney-grade PDFs)</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px',
                            fontWeight: '600'
                        }}>
                            <span style={{ color: '#8b5cf6', fontWeight: '700' }}>★</span>
                            <span style={{ color: '#8b5cf6' }}>Comparison Workspace Pro</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px',
                            fontWeight: '600',
                            paddingBottom: '16px',
                            borderBottom: '1px solid #e5e7eb'
                        }}>
                            <span style={{ color: '#8b5cf6', fontWeight: '700' }}>★</span>
                            <span style={{ color: '#8b5cf6' }}>Full Invention Assessment</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>Patent Decoder & Patentability Check</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>Tech Landscape & Competitive Intel</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>Collaborative Workspaces</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>Unlimited saves</span>
                        </li>
                        <li style={{ 
                            padding: '12px 0', 
                            color: '#334155',
                            fontSize: '15px',
                            display: 'flex',
                            alignItems: 'start',
                            gap: '8px'
                        }}>
                            <span style={{ color: '#10b981', fontWeight: '600' }}>✓</span>
                            <span>Export 1000 patents to CSV</span>
                        </li>
                    </ul>

                    <button 
                        onClick={() => alert('Pro upgrade coming soon!')}
                        style={{ 
                            width: '100%',
                            padding: '14px',
                            background: '#8b5cf6',
                            border: 'none',
                            borderRadius: '8px',
                            color: 'white',
                            fontSize: '16px',
                            fontWeight: '600',
                            cursor: 'pointer',
                            transition: 'all 0.2s'
                        }}
                        onMouseOver={(e) => e.target.style.background = '#7c3aed'}
                        onMouseOut={(e) => e.target.style.background = '#8b5cf6'}
                    >
                        Contact Us
                    </button>
                </div>
            </div>

            {/* Enterprise Section */}
            <div style={{ 
                maxWidth: '1200px', 
                margin: '0 auto 80px', 
                padding: '48px 24px',
                textAlign: 'center',
                background: '#f9fafb',
                borderRadius: '16px'
            }}>
                <h3 style={{ 
                    fontSize: '28px', 
                    fontWeight: '700', 
                    color: '#1d2934',
                    marginBottom: '16px'
                }}>
                    Need a custom plan?
                </h3>
                <p style={{ 
                    fontSize: '16px', 
                    color: '#64748b',
                    marginBottom: '24px'
                }}>
                    Contact us for enterprise pricing and custom solutions
                </p>
                <button 
                    onClick={() => window.location.href = 'mailto:contact@pattrak.com'}
                    style={{ 
                        padding: '14px 32px',
                        background: '#1d2934',
                        border: 'none',
                        borderRadius: '8px',
                        color: 'white',
                        fontSize: '16px',
                        fontWeight: '600',
                        cursor: 'pointer',
                        transition: 'all 0.2s'
                    }}
                    onMouseOver={(e) => e.target.style.background = '#334155'}
                    onMouseOut={(e) => e.target.style.background = '#1d2934'}
                >
                    Contact Sales
                </button>
            </div>

            {/* Footer */}
            <footer style={{
                padding: '32px 24px',
                borderTop: '1px solid #e5e7eb',
                textAlign: 'center',
                color: '#64748b',
                fontSize: '14px'
            }}>
                <p style={{ margin: 0 }}>
                    By using PatTrak, you agree to our{' '}
                    <a href="#" style={{ color: '#3b82f6', textDecoration: 'none' }}>Terms</a>
                    {' '}and have read our{' '}
                    <a href="#" style={{ color: '#3b82f6', textDecoration: 'none' }}>Privacy Policy</a>
                </p>
            </footer>
        </div>
    );
}